import slugify from 'slugify';
import _omit from 'lodash/omit';
import filterQuery from './filterQuery';
import getQueryFromSearchParams from './getQueryFromSearchParams';
import { AnalyticsMarkersGetter, FormState, Query, SubmitPayload } from '../types';

interface Options {
  analyticsMarkersGetter: AnalyticsMarkersGetter;
  canSpecifyTime: boolean;
  canSpecifyCheckinTime: boolean;
}

const getSubmitPayload = (data: FormState, query: Query, options: Options): SubmitPayload => {
  const { to, dates, rooms, lateCheckout, earlyCheckin } = data;

  /**
   * Нельзя сделать сабмит формы без дат
   */
  const { startDate, endDate } = dates as { startDate: Date; endDate: Date };
  const { analyticsMarkersGetter, canSpecifyTime, canSpecifyCheckinTime } = options;
  let omittedFields: string[] = [];

  if (!canSpecifyTime) {
    omittedFields = ['e_checkin', 'l_checkout'];
  } else if (!canSpecifyCheckinTime) {
    omittedFields = ['e_checkin'];
  }

  const countryName = to?.country_slug || query.country_name;
  const citySlugName = to?.city_slug || query.city_name;
  const preparedQuery = _omit(query, ['e_checkin', 'l_checkout']);

  if (to && to.type === 'hotel') {
    const { city_id: cityId, city_name: cityName, id: hotelId, name: hotelName } = to;
    const parsedHotelName = `${slugify(hotelName).toLowerCase()}-${hotelId}`;

    return {
      url: `/hotel/${parsedHotelName}`,
      params: filterQuery(
        {
          ...preparedQuery,
          ...getQueryFromSearchParams({
            to,
            rooms,
            startDate,
            endDate,
            lateCheckout,
            earlyCheckin,
          }),
          ...analyticsMarkersGetter(preparedQuery),
          country_name: countryName,
          city_name: citySlugName,
          to: cityName ? encodeURIComponent(cityName) : undefined,
          id: cityId,
          sc: cityId,
          type: 'geo',
          s: true,
        },
        omittedFields
      ),
    };
  }

  return {
    url: `/search/${countryName}/${citySlugName}`,
    params: filterQuery(
      {
        ...preparedQuery,
        ...getQueryFromSearchParams({ to, rooms, startDate, endDate, lateCheckout, earlyCheckin }),
        ...analyticsMarkersGetter(preparedQuery),
        page: 1,
        country_name: countryName,
        city_name: citySlugName,
        s: true,
      },
      omittedFields
    ),
  };
};

export default getSubmitPayload;
